import { environment } from 'environments/environment';

export class UrlHelper {
    /**
     * The URL requested, before initial routing.
     */
    static readonly initialUrl = location.href;

    static getQueryParameters(): any {
        return UrlHelper.getQueryParametersUsingParameters(document.location.search);
    }

    static getQueryParametersUsingParameters(search: string): any {
        return search.replace(/(^\?)/, '').split('&').map(function (n) { return n = n.split('='), this[n[0]] = n[1], this; }.bind({}))[0];
    }

    static getInitialUrlParameters(): any {
        let questionMarkIndex = UrlHelper.initialUrl.indexOf('?');
        if (questionMarkIndex >= 0) {
            return UrlHelper.initialUrl.substr(questionMarkIndex, UrlHelper.initialUrl.length - questionMarkIndex);
        }

        return '';
    }

    static getReturnUrl(): string {
        const queryStringObj = UrlHelper.getQueryParametersUsingParameters(UrlHelper.getInitialUrlParameters());
        if (queryStringObj.returnUrl) {
            return decodeURIComponent(queryStringObj.returnUrl);
        }

        return null;
    }

    static getSingleSignIn(): boolean {
        const queryStringObj = UrlHelper.getQueryParametersUsingParameters(UrlHelper.getInitialUrlParameters());
        if (queryStringObj.ss) {
            return queryStringObj.ss;
        }

        return false;
    }

    static isInstallUrl(url): boolean {
        return url && url.indexOf('app/admin/install') >= 0;
    }

    static isMaintenanceUrl(url): boolean {
        return url && url.indexOf('maintenance') >= 0;
    }

    static isApiStatusUrl(url): boolean {
        return url && url.indexOf('/api/Health/Ping') >= 0;
    }

    /**
     * Sends the browser to the maintenance page, preserving the current location so the page can
     * return here once the API is healthy again. A no-op if already on the maintenance page.
     */
    static redirectToMaintenance(): void {
        if (UrlHelper.isMaintenanceUrl(location.href)) {
            return;
        }

        const originalUrl = encodeURIComponent(location.href);
        let url = `/maintenance?originalUrl=${originalUrl}`;

        if (location.hostname.toLowerCase() === environment.WebFacingHost.toLowerCase()) {
            url = `/calculators/maintenance?originalUrl=${originalUrl}`;
        }

        location.href = url;
    }
}
